import { LegalLinksAndVersion } from '@Components/Legal/LegalLinksAndVersion';
import { BrandLogo } from '@Components/Navigation/BrandLogo';
import { FlexColumn, Modal } from '@synqo/frontend-component-library';

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export function CustomDomainNotFound() {
    return (
        <Modal isOpen onClose={() => false} withoutCloseButton>
            <FlexColumn>
                <BrandLogo width="100%" className="max-h-30" />
                <h2 className="m-0 text-xl">Adresse nicht gefunden</h2>
                <p className="m-0">Unter dieser Adresse ist kein Zugang eingerichtet. Bitte prüfen Sie die Adresse.</p>
                <LegalLinksAndVersion />
            </FlexColumn>
        </Modal>
    );
}
